import Vue from 'vue'
import VueQuillEditor from 'vue-quill-editor'
import { Quill } from 'vue-quill-editor'
import swal from 'sweetalert2'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

let Inline = Quill.import('blots/inline')

class LinkBlot extends Inline {
    static create(value) {
      let node = super.create();
      // Sanitize url value if desired
      node.setAttribute('href', value[0]);
      // Okay to set other non-format related attributes
      // These are invisible to Parchment so must be static
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', value[1] ? 'follow' : 'nofollow');
      return node;
    }
  
    static formats(node) {
      // We will only be called with a node already
      // determined to be a Link blot, so we do
      // not need to check ourselves
      return node.getAttribute('href');
    }
}

LinkBlot.blotName = 'link';
LinkBlot.tagName = 'a';

Quill.register(LinkBlot);

Vue.use(VueQuillEditor, {
    modules: {
        toolbar: {
            container: [
                ['bold', 'italic', 'underline', 'strike'],
                ["blockquote", "code-block"],
                [{ 'header': 1 }, { 'header': 2 }], 
                [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                [{ 'script': 'sub'}, { 'script': 'super' }],
                [{ 'indent': '-1'}, { 'indent': '+1' }],
                [{ 'direction': 'rtl' }],
                [{ 'size': ['small', false, 'large', 'huge'] }], 
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                [{ 'color': [] }, { 'background': [] }],
                [{ 'font': [] }],
                [{ 'align': [] }],
                ['clean'],
                ['link', 'image', 'video'],
            ],
            handlers: {
                // handlers object will be merged with default handlers object
                'link': async function(value) {
                    if (value) {
                        var { value: url } = await swal.fire({
                            allowOutsideClick: false,
                            title: 'Ingresar link',
                            html:
                                '<label for="swal-input1"> Link </label>' +
                                '<input type="url" id="swal-input1" class="swal2-input"></input>' +
                                '<label for="swal-input2"> Follow </label>' +
                                '<input type="checkbox" id="swal-input2" class="swal2-input"></input>',
                            focusConfirm: false,
                            preConfirm: () => {
                                return [
                                    document.getElementById('swal-input1').value,
                                    document.getElementById('swal-input2').checked
                                ]
                            },
                        })
                        if(!!url[0]) {
                            this.quill.format('link', url);
                        } else {
                            swal.fire({
                                icon: 'error',
                                text: 'El link no puede ser nulo!',
                                allowOutsideClick: false,
                            })
                        }
                    } else {
                        this.quill.format('link', false);
                    }
                }
            }
        }
    },
    placeholder: 'Ingrese un texto aquí',
})